export type BehaviourConditionOperator = "lt" | "gt" | "is" | "eq";

export const BATTERY_OPERATOR_LABELS: Record<"lt" | "gt", string> = {
    lt: "<",
    gt: ">",
};

export const BEHAVIOUR_CONDITION_OPERATOR_LABELS: Partial<Record<BehaviourConditionOperator, string>> = {
    lt: "<",
    gt: ">",
    is: "is",
    eq: "is",
};

export {
    NAVIGATE_GOAL_STATUS,
    NAVIGATE_GOAL_STATUS_OPTIONS,
    NAVIGATE_STATUS_SOURCE_ID,
    NAVIGATE_STATUS_TOPIC,
    NAVIGATE_CANCEL_EVENT_FIELD,
    NAVIGATE_CANCELED_FIELD,
    isNavigateCanceledSource,
    isNavigateCanceledCondition,
    isNavigateGoalStatusEnumSource,
    isNavigateStatusSource,
    normalizeNavigateStatusCondition,
    normalizeBehaviourCondition,
} from "lib/consts/navigateGoalStatus";

export const getBehaviourOperatorLabel = (
    sourceId: string | undefined,
    operator: string,
): string => {
    if (sourceId === "battery") {
        return BATTERY_OPERATOR_LABELS[operator as "lt" | "gt"] ?? operator;
    }
    return BEHAVIOUR_CONDITION_OPERATOR_LABELS[operator as BehaviourConditionOperator] ?? operator;
};

export const BEHAVIOUR_ACTION_TYPES = {
    RETURN_TO_LAUNCH: "return_to_launch",
    STOP_AND_HOLD: "stop_and_hold",
    RETRY_FAILED_ACTION: "retry_failed_action",
} as const;

export const RETRY_COUNT_OPTIONS = ["1", "2", "3", "4", "5"] as const;

export const RETRY_EXHAUSTED_REGULAR_OPTIONS = [
    { value: "return_to_launch", label: "Return to launch" },
    { value: "stop_and_hold", label: "Stop and hold position" },
] as const;

export const RETRY_EXHAUSTED_FAILURE_OPTIONS = [
    { value: "stop", label: "Stop mission" },
    { value: "rtl", label: "Return to launch" },
    { value: "continue", label: "Continue mission" },
] as const;

export const isBatteryEventSource = (source: { id?: string; topic?: string } | undefined) =>
    source?.id === "battery" || source?.topic === "/state/battery";

export const isRetryActionType = (actionType: string | undefined) =>
    actionType === BEHAVIOUR_ACTION_TYPES.RETRY_FAILED_ACTION ||
    actionType === "failure_retry";

export const defaultRetryActionParams = (failurePolicy = false) => ({
    retry_count: "1",
    on_exhausted: failurePolicy ? "stop" : "stop_and_hold",
    mode: "plan_to_launch",
});

export const defaultPlanNextActionParams = () => ({
    plan_next_max: "3",
    on_exhausted: "rtl",
    mode: "plan_to_launch",
    skip_follow_on_actions: "true",
});

export const createEmptyCondition = () => ({
    source: "ros_topic",
    topic: "/state/battery",
    field: "data",
    operator: "lt",
    value: "",
});

export const createEmptyRule = () => ({
    id: "",
    name: "New rule",
    enabled: true,
    conditions: {
        logic: "and",
        items: [createEmptyCondition()],
    },
    action: {
        type: BEHAVIOUR_ACTION_TYPES.RETURN_TO_LAUNCH,
        params: { mode: "plan_to_launch" },
    },
});
